import axios from 'axios';
import { staffClient } from 'clients/staff';

export const getS3UploadUrl = async (file: File) => {
  try {
    const response = await staffClient.get('/s3/generate-s3-url', {
      params: { filename: file.name, filetype: file.type },
    });

    if (response.status !== 200) {
      console.error('Failed to get signed URL.');
      return;
    }

    return response.data.url;
  } catch (error) {
    console.error('An error occurred during the image upload process:', error);
  }
}

export const uploadS3File = async (file: File, url: string) => {
  console.log('!!! FILE', file);
  try {
    const uploadResponse = await axios.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
    }); // do not use staffClient here because it will cause CORS error

    if (uploadResponse.status === 200) {
      // insertToEditor(url.split('?')[0]);
      return url.split('?')[0];
    } else {
      console.error('Failed to upload image.');
    }
  } catch (error) {
    console.error('An error occurred during the image upload process:', error);
  }
};
